module.exports = __webpack_public_path__ + "media/images/flags/ai-0e51972c264c2cb188c347cb5a5c1d80.svg";